import styled from "styled-components";

export const Styles = styled.div`
  .location-filter {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    padding: 0.8rem;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    border-bottom: 1px solid ${({ colors }) => colors.color.lightGrey};
  }

  .location-filter-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
      rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
    border-radius: 20px;
    padding: 10px;
    background: white;
    width: 825px;
    margin: 0 auto;
  }

  .search-section {
    width: 100%;
    order: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
  }

  .ai-search-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #ffffff;
    color: #aaa;
    border: 1.5px solid #e0e0e0;
    border-radius: 20px;
    padding: 0.45rem 0.9rem;
    font-size: 0.82rem;
    cursor: pointer;
    white-space: nowrap;
    max-width: 245px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    svg {
      color: #0fd3bb;
      flex-shrink: 0;
    }

    &:hover,
    &:focus {
      border-color: #0fd3bb;
      box-shadow: 0 0 0 3px rgba(15, 211, 187, 0.15);
      outline: none;
    }
  }

  .ai-search-placeholder {
    flex: 1;
    font-size: 0.82rem;
    color: #aaa;
    user-select: none;
  }

  .ai-search-badge {
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.5px;
    color: #fff;
    background: #0fd3bb;
    padding: 1px 7px;
    border-radius: 20px;
    flex-shrink: 0;
  }

  .ai-clear-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    background: transparent;
    color: #e74c3c;
    border: 1.5px solid #e74c3c;
    border-radius: 20px;
    padding: 0.4rem 0.9rem;
    font-size: 0.80rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.2s, color 0.2s;

    &:hover {
      background: #e74c3c;
      color: #fff;
    }
  }

  .switches-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    order: 2;
  }

  .search-location {
    width: 100%;
    max-width: 300px;
  }

  .locations-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 5px 15px;
    box-shadow: 0 0 5px 2px rgba(233, 229, 229, 0.9);
    border-radius: 20px;
    @media (max-width: 768px) {
      gap: 5px;
      padding: 5px 5px;
    }
    label{
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
  }

  .form-check-input:checked {
    background-color: ${({ colors }) => colors.color.secondary} !important;
    border-color: ${({ colors }) => colors.color.secondary} !important;
  }

  .form-check-input {
    border-color: ${({ colors }) => colors.color.lightGrey} !important;
    height: 20px !important;
    width: 40px !important;
    cursor: pointer;

    &:focus {
      border-color: none !important;
      background-img: none !important;
      box-shadow: none !important;
    }
  }

  .form-check-input:not(:checked):focus {
    --bs-form-switch-bg:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba(0, 0, 0, 0.25)'/%3e%3c/svg%3e") !important;
  }

  .search-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ colors }) => colors.color.secondary};
    height: 40px;
    width: 40px;
    border-radius: 50%;
    cursor: pointer;
  }

  .search-icon {
    width: 20px;
    height: 20px;
    color: white;
    fill: white;
  }

  .search-close {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ colors }) => colors.color.secondary};
    height: 30px;
    width: 30px !important;
    border-radius: 50%;
    cursor: pointer;
  }

  .custom-select__control {
    background-color: red !important;
    border-color: #ccc;
    border-radius: 4px;
    border-width: 1px;
    padding: 8px;
  }

  @media (min-width: 768px) {
    .location-filter {
      padding: 0.8rem;
    }

    .location-filter-wrapper {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 12px 15px;
      box-shadow: rgba(17, 12, 46, 0.15) 0px 4px 16px 0px;
      gap: 15px;
    }

    .search-section {
      flex: 0.4;
      order: unset;
      min-width: 250px;
      max-width: 300px;
      justify-content: flex-start;
    }

    .switches-section {
      flex: 0.6;
      justify-content: flex-end;
      order: unset;
      max-width: 350px;
    }

    .search-location {
      width: 100%;
      max-width: unset;
    }
  }

  @media (min-width: 1024px) {
    .location-filter-wrapper {
      gap: 25px;
    }
  }
  @media (max-width: 786px) {
    .switches-section {
      gap: 10px !important;
      flex-wrap: wrap;
    }
    .search-location {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
  .form-check-input {
    border-color: ${({ colors }) => colors.color.lightGrey} !important;
    height: 20px !important;
    width: 40px !important;
    @media (max-width: 768px) {
      width: 35px !important;
    }
  }

  .form-check-input:focus {
    border-color: none !important;
    background-img: none !important;
    box-shadow: none !important;
  }
  .form-check-input:checked:focus {
    --bs-form-switch-bg: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e) !important;
  }
  

  @media (max-width: 768px) {
    .location-filter-wrapper {
      width: auto;
    }
    .switches-section {
      gap: 7px !important;
      flex-wrap: wrap;
    }
    .search-location {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    /* ── 2-line layout for search section on mobile ── */
    .search-section {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
    .search-location {
      width: 100%;
      flex: 0 0 100%;        /* line 1: full width */
      max-width: 100%;
    }
    .ai-search-btn {
      flex: 0 0 100%;        /* line 2: same full width as autocomplete */
      max-width: 245px;
      min-width: 0;
    }
    .ai-clear-btn {
      flex: 0 0 100%;        /* line 3: full width if visible */
      max-width: 245px;
    }
  }
`;
